// @flow

import type { Node } from 'react';
import React, { createContext, useContext, useReducer } from 'react';

import reducer from './FundSuggestor.reducers';
import type { FundProviderProps } from './types';

const FundStateContext = createContext(null);

const FundDispatchContext = createContext(null);

export const useFundStateContext = () => useContext(FundStateContext);

export const useFundDispatchContext = () => useContext(FundDispatchContext);

export const FundProvider = ({ children }: FundProviderProps): Node => {
  const [state, dispatch] = useReducer(reducer, {
    error: null,
    funds: [],
    isFetched: false,
    isRequest: false,
  });

  return (
    <FundStateContext.Provider value={state}>
      <FundDispatchContext.Provider value={dispatch}>{children}</FundDispatchContext.Provider>
    </FundStateContext.Provider>
  );
};
